import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=0aaf4b86&scoped=true"
import script from "./Liquid.vue?vue&type=script&lang=js"
export * from "./Liquid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf4b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aaf4b86')) {
      api.createRecord('0aaf4b86', component.options)
    } else {
      api.reload('0aaf4b86', component.options)
    }
    module.hot.accept("./Liquid.vue?vue&type=template&id=0aaf4b86&scoped=true", function () {
      api.rerender('0aaf4b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/Liquid.vue"
export default component.exports